import { render, staticRenderFns } from "./normal.md?vue&type=template&id=57483e2c&"
import script from "./normal.md?vue&type=script&lang=js&"
export * from "./normal.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57483e2c')) {
      api.createRecord('57483e2c', component.options)
    } else {
      api.reload('57483e2c', component.options)
    }
    module.hot.accept("./normal.md?vue&type=template&id=57483e2c&", function () {
      api.rerender('57483e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/pie/normal.md"
export default component.exports